require("./ynetnews_vesty_site_redMailComponenta.less")
import { ExtraDetails } from "./extraDetails/extraDetailsYnetnews";
import { PopUpYnetnews } from "./popUp/popUpYnetnews";
import { RedMailFileUploadYnetnews } from "./filesUpload/filesUploadYnetnews";
import { RedMailComponentaProps } from "../../../redMail/interfaces/redMailInterfaces";
import {getTranslation} from "../redMailTranslations";
import classNames = require("classnames");

export interface RedMailComponentaYnetnewsProps extends RedMailComponentaProps {
    handleRemoveFile?: (fileKey: string) => void;
}

export class RedMailComponentaYnetnews extends React.Component<RedMailComponentaYnetnewsProps & {isChecked: boolean}, {}>{

      private focusFirstInvalidField = () => {
             const { isTextAreaBlank, isAgreementApproved, countSubmitAttempts } = this.props;
     
             const focusElement = (element: HTMLElement) => {
                 element.focus();
                 element.scrollIntoView({ behavior: "smooth", block: "center" });
             }
     
             if (isTextAreaBlank) {
                 const textArea = document.querySelector(".redMailFormContent .textAreaWrapper textarea") as HTMLTextAreaElement;
                 if (textArea) {
                     focusElement(textArea);
                     return;
                 }
             }
     
             const firstValidationError = document.querySelector(".redMailFormContent .redMail-error-validation") as HTMLElement;
             if (firstValidationError) {
                 const inputField = firstValidationError.closest(".inputField");
                 const invalidInput = inputField && inputField.querySelector("input") as HTMLInputElement;
                 if (invalidInput) {
                     focusElement(invalidInput);
                     return;
                 }
             }
     
             if (!isAgreementApproved && countSubmitAttempts > 0) {
                 const agreementInput = document.getElementById("agreementApproved") as HTMLInputElement;
                 if (agreementInput) {
                     focusElement(agreementInput);
                 }
             }
         }
     
         public componentDidUpdate(prevProps: RedMailComponentaYnetnewsProps & { isChecked: boolean }) {
             if (this.props.countSubmitAttempts > prevProps.countSubmitAttempts) {
                 setTimeout(this.focusFirstInvalidField, 0);
             }
         }


    public render() {
        const { handleChangeText, isTextAreaBlank, countSubmitAttempts, textArea,
                handleSelectedFile, selectedFiles, hashes, invalidFilesName, showFileStatusProgress,
                photographer, sender, mail, phoneNumber, validation, handleChangeExtraData, isAgreementApproved,
                IsPopUp, submitForm, loading, onClose, submitButtonDisabled, isChecked, handleRemoveFile, lang } = this.props;

        const ynetnewsTermsHref = "https://www.ynetnews.com/articles/0,7340,L-3048342,00.html";
        const ynetnewsPolicyHref = "https://www.ynetnews.com/articles/0,7340,L-3048313,00.html";
        const vestyTermsHref = "https://www.vesty.co.il/articles/0,7340,L-4867560,00.html";
        const vestyPolicyHref = "https://www.vesty.co.il/articles/0,7340,L-4867557,00.html";
        const TermsLink = <a href={lang === "en-GB" ? ynetnewsTermsHref : vestyTermsHref} className="termsClick">{getTranslation(lang, "terms of use")}</a>
        const PolicyLink = <a href={lang === "en-GB" ? ynetnewsPolicyHref : vestyPolicyHref} className="termsClick">{getTranslation(lang, "privacy policy")}</a>

        const textData = {
            headlineText: <>{getTranslation(lang, "red")} {getTranslation(lang, "mail")} </>,
            textArea: {
                textAreaHeadline: <>{getTranslation(lang, "headlineTitleRow1")}<br/>{getTranslation(lang, "headlineTitleRow2")}</>,
                textHere: getTranslation(lang, "share your info here"),
                placeholder: getTranslation(lang, "the information"),
            },
            extraDetailsData: {
                title: getTranslation(lang, "more details"), 
                subTitle: "",
                mailPattern: getTranslation(lang, "mail pattern")
            },
            terms: <span>{getTranslation(lang, "terms1")} {TermsLink} {getTranslation(lang, "terms2")} {PolicyLink}{getTranslation(lang, "terms3")}</span>
        }
        const redMailClassName = `RedMailComponentaYnetnews ${lang === "ru-RU" ? "vesty" : ""}`
        
        return (
            <div>
                <div className={redMailClassName}>
                    <div className="redMailLeftSide">
                    <div className="redMailHeadline">
                        <div className="headlineLogo">
                            <div className="headlineImage_circle">
                                <div className="headlineImage" />
                            </div>
                            <p className="headlineTitle">{textData.headlineText}</p>
                        </div>
                        <p className="headlineSubtitle">
                           {textData.textArea.textAreaHeadline}
                        </p>
                    </div>

                    {IsPopUp ? 
                         <PopUpYnetnews onClose={onClose} loading={loading} lang={lang} />
                        :
                        <div className="redMailFormWrapper">
                        <div className="redMailFormContent">
                            <p className="formContentTitle">{textData.textArea.textHere}</p>
                            <div className="textAreaWrapper">
                                <textarea
                                    dir="rtl"
                                    placeholder={textData.textArea.placeholder}
                                    value={textArea}
                                    resize="vertical"
                                    onChange={(e) => handleChangeText(e)}
                                    className={classNames({
                                        "placeholderErrorStyle": isTextAreaBlank,
                                        "invalidInput": isTextAreaBlank && countSubmitAttempts > 0
                                    })}
                                />
                            </div>
                            {(isTextAreaBlank && countSubmitAttempts > 0) && 
                            <div className="contentErrorMessage">{getTranslation(lang, "required")}</div>
                            }

                           <RedMailFileUploadYnetnews
                            handleSelectedFile={handleSelectedFile}
                            selectedFiles={selectedFiles}
                            hashes={hashes}
                            invalidFilesName={invalidFilesName}
                            showFileStatusProgress={showFileStatusProgress}
                            handleRemoveFile={handleRemoveFile}
                            lang={lang}
                            />

                            <div className="upload_text">
                                {`mov,png,jpeg,jpg,mp4 ${getTranslation(lang, "up to")} 200 MB`}
                            </div>

                            <ExtraDetails
                            photographer={photographer}
                            sender={sender}
                            mail={mail}
                            phoneNumber={phoneNumber}
                            onChange={handleChangeExtraData}
                            validation={validation}
                            extraDetailsData={textData.extraDetailsData}
                            lang={lang}
                            />

                            <div className="terms">
                                <input className="checkBox" id="agreementApproved" type="checkbox" checked={isAgreementApproved} onChange={(e) => handleChangeExtraData(e)} />
                                <p className="termsText">{textData.terms}</p>
                                {!isAgreementApproved && countSubmitAttempts > 0 && (
                                <div className="contentErrorMessage terms-error">
                                    {getTranslation(lang, "terms of use must be approved")}
                                </div>
                                )}
                            </div>
                        
                        <button
                            disabled={submitButtonDisabled}
                            className="submitButton"
                            type="submit"
                            onClick={submitForm}>
                           {getTranslation(lang, "send")}
                        </button>

                        </div>

                        {isChecked && <div className="redMailSharing">
                            <p className="sharingTitle">{getTranslation(lang, "another way to share")}</p>
                            <div className="sharingButtons">
                                 <a href="https://wa.me/972548243550" className="whatsappButton" target="_blank">
                                    <img alt="Whatsapp" />
                                    <div>Whatsapp</div>
                                </a>
                                <a href="https://t.me/ynetTbot" className="telegramButton" target="_blank">
                                    <img alt="Telegram" />
                                    <div>Telegram</div>
                                </a>                             
                            </div>
                        </div> 
                        }

                    </div>               
                       }
                 </div>
                </div>
              </div>         
 
        )

    }
}



